export class Brand {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new Brand(
      this.hash,
      this.name
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/brand.ts